export const texts = {
  title: {
    de: 'Skills',
    en: 'Skills'
  },
  noInformation: {
    de: 'Es liegen keine Angaben vor',
    en: 'No information available'
  }
};
